  document.querySelectorAll('.accordion-button').forEach(button => {
    button.addEventListener('click', function() {
      this.classList.toggle('active');
      let content = this.nextElementSibling;
      let icon = this.querySelector('.icon');
      if (content.style.display === 'block') {
        content.style.display = 'none';
        icon.textContent = '+';
      } else {
        content.style.display = 'block';
        icon.textContent = '-';
      }
    });
  });